/* eslint-disable @angular-eslint/directive-selector, @angular-eslint/directive-class-suffix */

import { computed, Directive, input } from '@angular/core';
import { SingleRenderInSourceDirectiveBase } from 'common-ui';
import { ItemResultRenderTarget, ItemResultRenderTargetComponents } from './ItemResultRenderTarget';

@Directive({
  selector: '[renderInItemResult]',
  standalone: true,
})
export class RenderInItemResultLayoutDirective extends SingleRenderInSourceDirectiveBase {
  public override renderArgs = input<string | undefined>(undefined, { alias: 'renderInItemResultId' });
  public override priority = input<number>(0, { alias: 'renderInItemResultPriority' });
  public readonly target = input<ItemResultRenderTarget, ItemResultRenderTarget | string | undefined>(
    ItemResultRenderTarget.ImportantInfo,
    {
      alias: 'renderInItemResult',
      transform: (value) => (value as ItemResultRenderTarget) ?? ItemResultRenderTarget.ImportantInfo,
    },
  );
  protected readonly renderIn = computed(
    () => ItemResultRenderTargetComponents[this.target()] || ItemResultRenderTargetComponents[ItemResultRenderTarget.ImportantInfo],
  );
}
